import React from "react";
import { Row, Col, Breadcrumb } from "react-bootstrap";
import PaperFullContent from "../../components/Paper/List";

const PaperFull = () => {
    return (
        <div>
            <Row>
                <Col className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                    <h3>List Paper</h3>
                    <Breadcrumb className="breadcrumb-page-list align-items-center mb-0 lh-1">
                        <Breadcrumb.Item href="/dashboard/">
                            <div className="d-flex align-items-center text-decoration-none">
                                <i className="ri-home-4-line fs-18 text-primary me-1"></i>
                                <span className="text-secondary fw-medium hover">Dashboard</span>
                            </div>
                        </Breadcrumb.Item>

                        <Breadcrumb.Item active>
                            <span className="fw-medium">Paper</span>
                        </Breadcrumb.Item>

                        <Breadcrumb.Item active>
                            <span className="fw-medium">List</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>

            <PaperFullContent />
        </div>
    );
};

export default PaperFull;